import React from 'react';
import { graphql } from 'gatsby';
import { useIntl } from 'gatsby-plugin-intl';

import Layout from '../components/Layout';
import SEO from '../components/seo';
import { DeviceProducts } from '../components/Sections/DeviceProducts';

function ScreenPage({ data }) {
  const { formatMessage } = useIntl();

  return (
    <Layout isHomepage>
      <SEO
        keywords={[`bluli`, `blue-light`, `screen-protectors`, `e-commerce`]}
        title={formatMessage({ id: 'menu.screens' })}
      />

      <DeviceProducts products={data.allShopifyProduct.edges} />
    </Layout>
  );
}

export const query = graphql`
  query ShopifyCollections {
    allShopifyProduct {
      edges {
        node {
          title
          handle
          productType
          variants {
            id
            shopifyId
            price
            priceV2 {
              amount
              currencyCode
            }
            compareAtPrice
            compareAtPriceV2 {
              amount
              currencyCode
            }
            availableForSale
            title
          }
        }
      }
    }
  }
`;

export default ScreenPage;
